import { IAppState } from '../../../AppModulesWrapper';

export function selectOfferCategory(state: IAppState): string {
  return state.servicePickerWidget.offer.category;
}
